import { css } from '@emotion/react'
import { ExternalStyles } from 'bold-ui'
import { ReactNode, useMemo } from 'react'

import { MCHAT_RF_RESULTADO_BY_STATUS, MChatRfResultadoStatus } from '../model-mChatRf'

interface MChatRfResultadoAlertProps {
  status: MChatRfResultadoStatus
  children: ReactNode
  style?: ExternalStyles
}

export function MChatRfResultadoAlert(props: Readonly<MChatRfResultadoAlertProps>) {
  const { status, children, style } = props

  const styles = useMemo(() => createStyles(status), [status])

  return <div css={[styles.alert, style]}>{children}</div>
}

const createStyles = (status: MChatRfResultadoStatus) => {
  const { colorScale } = MCHAT_RF_RESULTADO_BY_STATUS[status]

  return {
    alert: css`
      color: ${colorScale.c40};
      padding: 0.5rem 1rem;
      background-color: ${colorScale.c90};
      border-left: 0.25rem solid ${colorScale.c40};
    `,
  }
}
